import { CaseTypeRepository } from '@telespot/domain';

export interface ICountCaseTypesQuery {
  /**
   * Counts case types matching an optional search term.
   * Repository errors propagate so the caller can update its error state.
   */
  execute(searchTerm?: string): Promise<number>;
}

export class CountCaseTypesQuery implements ICountCaseTypesQuery {
  constructor(private readonly caseTypeRepository: CaseTypeRepository) {}

  public async execute(searchTerm?: string): Promise<number> {
    return this.caseTypeRepository.count(searchTerm);
  }
}
